import React from 'react';

interface DocFinderIconProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg' | 'xl';
}

export const DocFinderIcon: React.FC<DocFinderIconProps> = ({ 
  className = '', 
  size = 'md' 
}) => {
  const sizeClasses = {
    sm: 'w-6 h-6',
    md: 'w-10 h-10',
    lg: 'w-12 h-12',
    xl: 'w-16 h-16'
  };

  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      viewBox="0 0 32 32" 
      className={`${sizeClasses[size]} ${className}`}
    >
      <path 
        d="M16 8 C12 8 9 11 9 15 C9 19 16 24 16 24 C16 24 23 19 23 15 C23 11 20 8 16 8 Z" 
        fill="currentColor"
      />
      <path 
        d="M14 13 L18 13 M16 11 L16 15" 
        stroke="currentColor" 
        strokeWidth="1.5" 
        strokeLinecap="round"
        opacity="0.8"
      />
    </svg>
  );
};
